import React, {} from 'react';

interface BottomNavigationProps {}

const GundamResourceSdk: React.FC<BottomNavigationProps> = (props: BottomNavigationProps) => null;

export default GundamResourceSdk;
